import { BookOpen, Library, BookMarked, Sparkles, Newspaper, Gamepad2, Hash, Layers } from "lucide-react";
import HubLayout from "./HubLayout";

export default function Practice() {
  const day = Number(localStorage.getItem("currentDay") || 1);

  return (
    <HubLayout
      eyebrow="Practice"
      headline="Build the"
      italic="foundations."
      subhead="The unsexy work that quietly makes everything else click — words, patterns, idioms, the lesson of the day."
      cards={[
        {
          Icon: BookOpen, accent: "var(--gold-500)",
          title: "Today's lesson",
          lede: `Day ${day}. Twenty minutes of structured input — the sentence, the words, the pattern, the practice.`,
          to: `/lesson/${day}`,
        },
        {
          Icon: Library, accent: "var(--sage)",
          title: "Build your vocabulary",
          lede: "Curated word lists with examples, pronunciation, and the why. Tap, hear, save.",
          to: "/vocabulary",
        },
        {
          Icon: BookMarked, accent: "var(--rust)",
          title: "Short stories",
          lede: "Two-minute reads at your level. Comprehension that doesn't feel like a test.",
          to: "/stories",
        },
        {
          Icon: Sparkles, accent: "var(--gold-500)",
          title: "Idioms",
          lede: "Spill the beans, cost an arm and a leg. The phrases that make English sound like English.",
          to: "/idioms",
        },
        {
          Icon: Newspaper, accent: "var(--sky)",
          title: "Reading practice",
          lede: "Articles with on-tap definitions and a question or two at the end.",
          to: "/reading",
        },
        {
          Icon: Gamepad2, accent: "var(--rust)",
          title: "Mini games",
          lede: "Word matching, sentence building, listen-and-pick. Five minutes when you can't do an hour.",
          to: "/mini-games",
        },
        {
          Icon: Hash, accent: "var(--ink-700)",
          title: "Phrases library",
          lede: "Ready-made phrases for greetings, opinions, agreement, polite disagreement.",
          to: "/phrases",
        },
        {
          Icon: Layers, accent: "var(--sage)",
          title: "Topics",
          lede: "Browse by what you want to talk about — work, travel, family, hobbies, health.",
          to: "/topics",
        },
      ]}
    />
  );
}
